import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-6 shadow" }
const _hoisted_2 = { class: "card-body pt-9 pb-0" }
const _hoisted_3 = { class: "d-flex flex-wrap flex-sm-nowrap justify-content-between" }
const _hoisted_4 = { class: "me-5" }
const _hoisted_5 = { class: "me-0 mb-0 text-end" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex overflow-auto h-55px" }, [
  /*#__PURE__*/_createElementVNode("ul", { class: "nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap" }, [
    /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link text-active-primary me-6 active",
        href: "#tabs_edit_general",
        "data-bs-toggle": "tab"
      }, "Thông tin chung")
    ]),
    /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link text-active-primary me-6",
        href: "#tabs_edit_content",
        "data-bs-toggle": "tab"
      }, "Nội dung")
    ]),
    /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
      /*#__PURE__*/_createElementVNode("a", {
        class: "nav-link text-active-primary me-6",
        href: "#tabs_edit_seo",
        "data-bs-toggle": "tab"
      }, "SEO")
    ])
  ])
], -1)
const _hoisted_8 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_9 = { class: "card-body pt-10" }
const _hoisted_10 = { class: "tab-content" }
const _hoisted_11 = {
  class: "tab-pane fade active show",
  id: "tabs_edit_general",
  item: "tabpanel"
}
const _hoisted_12 = { class: "my-5 px-8" }
const _hoisted_13 = { class: "row g-9 mb-8" }
const _hoisted_14 = { class: "col-md-8 fv-row" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold" }, "Tên bài review", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold" }, "Đường dẫn review", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { class: "required fs-6 fw-bold" }, "Loại review", -1)
const _hoisted_18 = { class: "row" }
const _hoisted_19 = { class: "col-md-6 fv-row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Tỉnh/Thành Phố", -1)
const _hoisted_21 = { class: "col-md-6 fv-row" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Quận/Huyện", -1)
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-6 fv-row" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2 required" }, "Phường/Xã", -1)
const _hoisted_26 = { class: "col-md-6 fv-row" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold mb-2" }, "Đường", -1)
const _hoisted_28 = { class: "row" }
const _hoisted_29 = { class: "col-md-12 fv-row" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h3", null, "Bản đồ", -1)
const _hoisted_31 = { class: "fst-italic fs-5 my-3" }
const _hoisted_32 = { class: "position-relative" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("input", {
  id: "address",
  type: "text",
  class: "form-control border-gray-500"
}, null, -1)
const _hoisted_34 = {
  ref: "mapDiv",
  style: {"width":"100%","height":"40vh"}
}
const _hoisted_35 = { class: "col-md-4 fv-row" }
const _hoisted_36 = { class: "d-flex justify-content-between" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("h3", { class: "required fs-6 fw-bold" }, "Ảnh đại diện", -1)
const _hoisted_38 = { class: "svg-icon svg-icon-2" }
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Chọn ảnh ")
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "col-md-12 fv-row" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("span", { class: "demonstration required" }, "Chọn ngày đăng bài", -1)
const _hoisted_43 = { class: "date-picker" }
const _hoisted_44 = { class: "block" }
const _hoisted_45 = { class: "col-md-8 fv-row mt-5" }
const _hoisted_46 = { class: "d-flex justify-content-between fs-6 fw-bold" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("h3", null, "Hình ảnh", -1)
const _hoisted_48 = { class: "svg-icon svg-icon-2" }
const _hoisted_49 = /*#__PURE__*/_createTextVNode(" Chọn ảnh ")
const _hoisted_50 = { class: "d-flex flex-wrap" }
const _hoisted_51 = { class: "image-input image-galleries p-4 image-input-outline m-2 w-100" }
const _hoisted_52 = {
  class: "image-input-wrapper h-150px w-100",
  style: `width:299px;`
}
const _hoisted_53 = ["src"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x fs-3 text-white" }, null, -1)
const _hoisted_56 = [
  _hoisted_55
]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 fv-row mt-0" }, null, -1)
const _hoisted_58 = {
  class: "tab-pane fade",
  id: "tabs_edit_content",
  item: "tabpanel"
}
const _hoisted_59 = { class: "my-5 px-8" }
const _hoisted_60 = { class: "row g-9 mb-10 mt-2 mb-2" }
const _hoisted_61 = { class: "col-md-10 fv-row mt-1" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Tóm tắt nội dung")
], -1)
const _hoisted_63 = { class: "col-md-10 fv-row mt-1" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Đường dẫn video")
], -1)
const _hoisted_65 = { class: "col-md-10 fv-row mt-1" }
const _hoisted_66 = { class: "d-flex align-items-center fs-6 fw-bold" }
const _hoisted_67 = { class: "col-md-2 fv-row mt-1" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-plus-circle fs-4" }),
  /*#__PURE__*/_createTextVNode(" Thêm nội dung ")
], -1)
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = ["onClick"]
const _hoisted_71 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-dash-circle fs-4" }, null, -1)
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = { class: "col-md-10 fv-row mt-1" }
const _hoisted_74 = { class: "d-flex align-items-center fs-6 fw-bold" }
const _hoisted_75 = { class: "editor-420" }
const _hoisted_76 = {
  class: "tab-pane fade",
  id: "tabs_edit_seo",
  item: "tabpanel"
}
const _hoisted_77 = { class: "d-flex flex-column px-9" }
const _hoisted_78 = { class: "row g-9 mb-8" }
const _hoisted_79 = { class: "col-md-12 fv-row" }
const _hoisted_80 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Robots", -1)
const _hoisted_81 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Tiêu đề seo", -1)
const _hoisted_82 = /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Nội dung seo", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_editor = _resolveComponent("editor")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    id: "add_experience_form",
    model: _ctx.objectData,
    rules: _ctx.rules,
    ref: "formRef",
    class: "form"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_affix, { offset: 120 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("h1", null, _toDisplayString(_ctx.objectData.name), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      class: "btn-primary btn",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.submit())),
                      loading: _ctx.loading
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.loading ? "Đang xử lý..." : "Lưu lại"), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ])
                ])
              ]),
              _hoisted_7
            ])
          ])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _hoisted_15,
                    _createVNode(_component_el_form_item, { prop: "name" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.convertNameToSlug(_ctx.objectData.name))),
                          modelValue: _ctx.objectData.name,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.objectData.name) = $event)),
                          placeholder: "Tiêu đề review",
                          name: "name"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_16,
                    _createVNode(_component_el_form_item, { prop: "slug" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.slug,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.objectData.slug) = $event)),
                          placeholder: "Đường dẫn dự án sẽ được tạo tự động từ tiêu đề",
                          name: "slug"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_17,
                    _createVNode(_component_el_form_item, { prop: "type" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.objectData.type,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.objectData.type) = $event)),
                          placeholder: "Chọn loại hình dự án"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              value: "du_an",
                              label: "Dự án"
                            }),
                            _createVNode(_component_el_option, {
                              value: "dia_diem",
                              label: "Địa điểm"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("div", _hoisted_19, [
                        _hoisted_20,
                        _createVNode(_component_el_form_item, { prop: "location.province_id" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              filterable: "",
                              "data-is-search": "true",
                              modelValue: _ctx.objectData.location.province_id,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.objectData.location.province_id) = $event)),
                              "default-first-option": "",
                              placeholder: "Chọn Tỉnh/Thành Phố",
                              onChange: _cache[6] || (_cache[6] = ($event: any) => (
                            _ctx.onChangeLocation(_ctx.objectData.location.province_id)
                          )),
                              rules: [
                            {
                              required: true,
                              message: 'Please input email address',
                              trigger: 'blur',
                            },
                          ]
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDataProvince, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.name,
                                    value: item._id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_21, [
                        _hoisted_22,
                        _createVNode(_component_el_form_item, { prop: "location.district_id" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              filterable: "",
                              "data-is-search": "true",
                              modelValue: _ctx.objectData.location.district_id,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.objectData.location.district_id) = $event)),
                              "default-first-option": "",
                              placeholder: "Chọn Quận/Huyện",
                              onChange: _cache[8] || (_cache[8] = ($event: any) => (
                            _ctx.onChangeDistrict(_ctx.objectData.location.district_id)
                          ))
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDataDistrict, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.name,
                                    value: item._id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createVNode(_component_el_form_item, { prop: "location.ward_id" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              filterable: "",
                              "data-is-search": "true",
                              modelValue: _ctx.objectData.location.ward_id,
                              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.objectData.location.ward_id) = $event)),
                              "default-first-option": "",
                              placeholder: "Chọn Phường/Xã",
                              onChange: _ctx.onChangeWard
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDataWard, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.name,
                                    value: item._id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _hoisted_27,
                        _createVNode(_component_el_form_item, { prop: "location.street_id" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              filterable: "",
                              "data-is-search": "true",
                              modelValue: _ctx.objectData.location.street_id,
                              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.objectData.location.street_id) = $event)),
                              "default-first-option": "",
                              placeholder: "Chọn Đường",
                              onChange: _ctx.onChangeStreet
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDataStreet, (item, index) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: index,
                                    label: item.name,
                                    value: item._id
                                  }, null, 8, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 1
                            }, 8, ["modelValue", "onChange"])
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.currPos), 1),
                        _createElementVNode("div", _hoisted_32, [
                          _hoisted_33,
                          _createElementVNode("div", _hoisted_34, null, 512)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_35, [
                    _createElementVNode("div", _hoisted_36, [
                      _hoisted_37,
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showSingleMedia('thumbnail'))),
                        class: "btn btn-primary btn-sm end",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        "data-kt-menu-flip": "top-end"
                      }, [
                        _createElementVNode("span", _hoisted_38, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen006.svg" }),
                          _hoisted_39
                        ])
                      ])
                    ]),
                    _createVNode(_component_el_form_item, {
                      prop: "image",
                      class: "mt-4"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("img", {
                          style: {"width":"100%"},
                          src: _ctx.renderImageUrl(_ctx.objectData.thumbnail, 'medium'),
                          alt: ""
                        }, null, 8, _hoisted_40)
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_41, [
                      _createVNode(_component_el_form_item, { label: "Trạng thái hiển thị" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.objectData.status,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.objectData.status) = $event)),
                            "active-color": "#13ce66",
                            "inactive-color": "#ff4949",
                            "active-value": "active",
                            "inactive-value": "inactive"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _hoisted_42,
                      _createElementVNode("div", _hoisted_43, [
                        _createElementVNode("div", _hoisted_44, [
                          _createVNode(_component_el_form_item, { prop: "published_at" }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.objectData.published_at,
                                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.objectData.published_at) = $event)),
                                type: "date",
                                placeholder: "Chọn ngày",
                                "disabled-date": _ctx.disabledDate
                              }, null, 8, ["modelValue", "disabled-date"])
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _hoisted_47,
                      _createElementVNode("button", {
                        type: "button",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.showMultipleMedia('images'))),
                        class: "btn btn-primary btn-sm end",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        "data-kt-menu-flip": "top-end"
                      }, [
                        _createElementVNode("span", _hoisted_48, [
                          _createVNode(_component_inline_svg, { src: "/media/icons/duotune/general/gen006.svg" }),
                          _hoisted_49
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_50, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objectData.images, (img, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: "col-md-4"
                        }, [
                          _createElementVNode("div", _hoisted_51, [
                            _createElementVNode("div", _hoisted_52, [
                              _createElementVNode("img", {
                                class: "w-100",
                                style: {"object-fit":"cover","height":"150px"},
                                src: _ctx.renderImageUrl(img, 'medium'),
                                alt: ""
                              }, null, 8, _hoisted_53)
                            ]),
                            _createElementVNode("label", {
                              class: "btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-danger shadow",
                              "data-kt-image-input-action": "change",
                              "data-bs-toggle": "tooltip",
                              onClick: ($event: any) => (
                              _ctx.removeImages({ name: 'images', index: index })
                            )
                            }, _hoisted_56, 8, _hoisted_54)
                          ])
                        ]))
                      }), 128))
                    ])
                  ]),
                  _hoisted_57
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_58, [
              _createElementVNode("div", _hoisted_59, [
                _createElementVNode("div", _hoisted_60, [
                  _createElementVNode("div", _hoisted_61, [
                    _hoisted_62,
                    _createVNode(_component_el_form_item, { prop: "short_content" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          modelValue: _ctx.objectData.short_content,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.objectData.short_content) = $event)),
                          placeholder: "Mô tả ngắn gọn",
                          rows: "4",
                          name: "short_content"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_63, [
                    _hoisted_64,
                    _createVNode(_component_el_form_item, { prop: "short_content" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "textbox",
                          modelValue: _ctx.objectData.video,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.objectData.video) = $event)),
                          placeholder: "Nhập đường dẫn video",
                          rows: "4",
                          name: "video"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.objectData.contents, (item, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "row g-9 mb-10 mt-2 mb-2"
                  }, [
                    _createElementVNode("div", _hoisted_65, [
                      _createElementVNode("label", _hoisted_66, [
                        _createElementVNode("h3", null, "Tiêu đề " + _toDisplayString(index + 1), 1)
                      ]),
                      _createVNode(_component_el_form_item, { prop: "short_content" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            type: "textbox",
                            modelValue: _ctx.objectData.contents[index].title,
                            "onUpdate:modelValue": ($event: any) => ((_ctx.objectData.contents[index].title) = $event),
                            placeholder: "Tiêu đề",
                            rows: "4",
                            name: "short_content"
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      _withDirectives(_createElementVNode("button", {
                        type: "button",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.addContent())),
                        class: "btn btn-primary btn-sm end",
                        "data-kt-menu-trigger": "click",
                        "data-kt-menu-placement": "bottom-end",
                        "data-kt-menu-flip": "top-end"
                      }, _hoisted_69, 512), [
                        [_vShow, index == 0]
                      ]),
                      _withDirectives(_createElementVNode("button", {
                        class: "btn btn-sm btn-danger rounded",
                        type: "button",
                        onClick: ($event: any) => (_ctx.removeContent(index))
                      }, _hoisted_72, 8, _hoisted_70), [
                        [_vShow, index != 0]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _createElementVNode("label", _hoisted_74, [
                        _createElementVNode("h3", null, "Nội dung " + _toDisplayString(index + 1), 1)
                      ]),
                      _createElementVNode("div", _hoisted_75, [
                        _createVNode(_component_editor, {
                          "api-key": "eik426uetuniwvflvp9ffcqc9kr6j4bt8lgskfghdki0lsjf",
                          modelValue: _ctx.objectData.contents[index].description,
                          "onUpdate:modelValue": ($event: any) => ((_ctx.objectData.contents[index].description) = $event),
                          init: _ctx.editorConfig
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "init"])
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_76, [
              _createElementVNode("div", _hoisted_77, [
                _createElementVNode("div", _hoisted_78, [
                  _createElementVNode("div", _hoisted_79, [
                    _hoisted_80,
                    _createVNode(_component_el_form_item, { prop: "robot" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _ctx.objectData.seo.robot,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.objectData.seo.robot) = $event)),
                          placeholder: "",
                          name: "robot"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "index, follow",
                              value: "index, follow"
                            }),
                            _createVNode(_component_el_option, {
                              label: "index, nofollow",
                              value: "index, nofollow"
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_81,
                    _createVNode(_component_el_form_item, { prop: "seo.title" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.seo.title,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.objectData.seo.title) = $event)),
                          placeholder: "",
                          name: "seo_title"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _hoisted_82,
                    _createVNode(_component_el_form_item, { prop: "seo.description" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.objectData.seo.description,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.objectData.seo.description) = $event)),
                          placeholder: "",
                          name: "seo_des",
                          rows: "4",
                          type: "textarea"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}